import { render } from "./t1.vue?vue&type=template&id=1a4442b4&scoped=true"
import script from "./t1.vue?vue&type=script&lang=js"
export * from "./t1.vue?vue&type=script&lang=js"

import "./t1.vue?vue&type=style&index=0&id=1a4442b4&scoped=true&lang=css"

import exportComponent from "D:\\网页文件\\新闻网专题\\2023ZT\\Fzsp\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4442b4"]])

export default __exports__